import {
  UseQueryOptions,
  UseQueryResult,
  useQuery,
  QueryKey,
} from '@tanstack/react-query';
import { IFHError } from '../../../../apis/HttpBaseApiWrapper';
import { useStudentsService } from '../../../../apis/students/useStudentsService';
import { TPaginationParams } from '../../../../apis/__shared/shared.interfaces';
import { TAttendanceByUserResponse } from '../../../../apis/__shared/attendance.interfaces';

type TQueryError = IFHError<{ message: string }>;
export const getStudentAttendanceByUserKey = 'get-student-attendance-by-user';

/** Shared with callers using `ensureQueryData` so row-click does not duplicate network vs context `useQuery`. */
export function buildStudentAttendanceByUserQueryKey(
  params: TPaginationParams,
  classId?: string,
  sectionId?: string,
  fromDate?: Date,
  toDate?: Date,
  studentId?: string
): QueryKey {
  return [
    getStudentAttendanceByUserKey,
    params.page,
    params.limit,
    classId,
    sectionId,
    fromDate?.toISOString(),
    toDate?.toISOString(),
    studentId,
  ];
}

export const useStudentAttendanceByUserHook = (
  params: TPaginationParams,
  classId?: string,
  sectionId?: string,
  fromDate?: Date,
  toDate?: Date,
  studentId?: string,
  options?: Omit<UseQueryOptions<TAttendanceByUserResponse, TQueryError, TAttendanceByUserResponse, QueryKey>, 'queryKey' | 'queryFn'>
): UseQueryResult<TAttendanceByUserResponse, TQueryError> => {
  const { getStudentAttendanceByUser } = useStudentsService();

  const queryKey = buildStudentAttendanceByUserQueryKey(
    params,
    classId,
    sectionId,
    fromDate,
    toDate,
    studentId
  );

  return useQuery<TAttendanceByUserResponse, TQueryError>({
    queryKey,
    queryFn: () =>
      getStudentAttendanceByUser(
        params,
        classId,
        sectionId,
        fromDate,
        toDate,
        studentId
      ),
    enabled: true,
    ...options,
  });
};

